import React, { Component } from 'react'
import { Container, InputField } from './styles'
import IcSearch from '../Icon/icSearch'

class RoundedInput extends Component {
  state = { focused: false }

  setFocus = () => {
    this.setState({ focused: true })
  }
  setBlur = () => {
    this.setState({ focused: false })
  }

  render() {
    const { focused } = this.state
    return (
      <Container focused={focused} empty={this.props.pristine}>
        <InputField
          {...this.props}
          empty={this.props.pristine}
          placeholder={this.props.placeholder}
          focused={focused}
          onFocus={() => this.setFocus()}
          onBlur={() => this.setBlur()}
        />
        <IcSearch {...this.props} focused={focused} />
      </Container>
    )
  }
}

export default RoundedInput



// WEBPACK FOOTER //
// ./src/app/elements/RoundedInput/RoundedInput.js